const EMAIL_DOMAINS = [
  "yahoo.com",
  "gmail.com",
  "yahoo.ro",
  "hotmail.com",
  "ymail.com",
  "yahoo.co.uk",
  "icloud.com",
  "yahoo.it",
  "outlook.com",
  "yahoo.fr",
  "freemail.hu",
  "yahoo.es",
  "yahoo.de",
  "live.com",
  "yahoo.ca",
  "rocketmail.com",
  "mail.com",
  "me.com",
  "gmail.ro",
  "protonmail.com",
  "mail.ru",
  "yahoo.com.au",
  "hotmail.it",
  "msn.com",
  "hotmail.co.uk",
  "yahoo.co.nz",
  "yahoo.com.sg",
  "gmail.hu",
  "hotmail.es",
  "live.it",
  "hotmail.fr",
  "icloud.ro",
  "hotmail.ro",
  "yahoo.co.in",
  "ymail.ro",
  "yahoo.hu",
  "hotmail.de",
  "yahoo.se",
  "live.co.uk",
  "aol.com",
];

export default EMAIL_DOMAINS;
